 $( document ).ready(function() {
  $('.input-number-increment').click(function() {
    var $input = $(this).parents('.input-number-group').find('.input-number');
    var val = parseInt($input.val(), 10);
    $input.val(val + 1);
  });
    });
   $( document ).ready(function() {
  $('.input-number-decrement').click(function() {
    var $input = $(this).parents('.input-number-group').find('.input-number');
    var val = parseInt($input.val(), 10);
    $input.val(Math.max(val - 1, 1));
  });
  });
function showMore(e) {
    var elementId = e.target.getAttribute('data-this-id');
    $(`#${elementId} p`).toggleClass('remove-clamp');
    if(e.target.innerText == "READ MORE") {
      e.target.innerText = "READ LESS";
    } else {
      e.target.innerText = "READ MORE";
    }
  }
  function preventDefault(e){
    e.preventDefault();
  }
  function disableScroll(){
      document.body.addEventListener('touchmove', preventDefault, { passive: false });
  }
  function enableScroll(){
      document.body.removeEventListener('touchmove', preventDefault);
  }
  $(document).ready(function() {
  //const BASE_URL = 'https://fp-practitioners-api.pwstaging.com.au';
  const BASE_URL = 'https://functionalpatterns.app';
  //const FETCH_OPTIONS = { headers: { 'x-access-key': '9pJ97Lj6jVD83N2c', 'x-secret-access-key': '28044729-e7ba-4e69-927b-0560991e0302'} };
  const $countries = $('#countries');
  const $cities = $('#cities');
  const $search = $('#search');    
  const $close = $('#close');
  const $practitioners = $('#practitioners');
  const $modal = $('#modal');
  const $loadMore = $( "#triggerLoadMore" );
  let countries = {};
  let practitioners = {};
  const getCountires = async () => {
    const res = await fetch(`${BASE_URL}/api/practitionersCountry`/*, FETCH_OPTIONS*/);
    countries = await res.json();
    for(objKey in countries) {
      const o = new Option(countries[objKey].name, countries[objKey].code);
      /// jquerify the DOM object 'o' so we can use the html method
      $(o).html(countries[objKey].name);
      $countries.append(o);
    }
  };
  const getPractitioners = async (country, city, page) => {
    const apiURL = `${BASE_URL}/api/practitionersOnly?page=${page}&country_code=${country}&city=${city}`;
    // console.log(city);
    // console.log("APIURL: " + apiURL);
    const res = await fetch(apiURL/*, FETCH_OPTIONS*/);
    // console.log(res.json);
    return await res.json();
  };
const showModal = (practitioner) => {
  $('#practitioners--avatar').attr('src', practitioner.avatar ? practitioner.avatar : 'https://via.placeholder.com/360');
  $('#practitioners--first_name').text(practitioner.first_name);
  $('#practitioners--last_name').text(practitioner.last_name);
  $('#practitioners--first_name1').text(practitioner.first_name);
  $('#practitioners--last_name1').text(practitioner.last_name);
  $('#practitioners--level').html(`<i class="fas fa-check-circle"></i> ${practitioner.level}`);
  $('#practitioners--address').html(`<span>Training out of</span> ${practitioner.address.city}, ${practitioner.address.country.name}`);
  $('#practitioners--name').text(practitioner.first_name);
  // Prefill the recipient address
  $('#hidden').val(practitioner.email);
  if(practitioner.testimonials.length != 0) {
    practitioner.testimonials.forEach((t, index) => {
    $('#practitioners--testimonials').append($(
      `
      <div class="testimonial-content" id="testimonial-content">
        <div id="testimonials-${index}" class="text-wrapper">
          <p  class="testimonials-text">${t.content}</p>
        </div>
        <a onclick="showMore(event)" href="#" class="read" data-this-id="testimonials-${index}">Read more</a>
      </div>
      `
    ));
    var theparagraph = document.querySelector(`#testimonials-${index} p`);
    if(theparagraph != null){
      $clamp(theparagraph, {clamp: 3, useNativeClamp: true, animate: true});
    }
  });
  } else {
      $('#practitioners--testimonials').append($(
        `
        <div class="testimonial-content" id="testimonial-content">
          <div class="text-wrapper">
          <p class="no-testimonials">No testimonials to show</p>
          </div>
        </div>
        `
      ));
    }
  $(document.body).addClass('body-class');
  //$modal.show();
      $('#modal').bPopup({
    closeClass:'closePop',
    modalClose: false
  });
}
$countries.on('change', (e) => { 
  const country = $('#countries option:selected').val();
  $cities.empty();
  countries[country].cities.forEach(c => {
    const o = new Option(c, c);
    $(o).html(c);
    $cities.append(o);
  });
  $cities.show();
});
const initPractitionerSearch = async (page, empty) => {
    const country = $('#countries option:selected').val();
    const city = $('#cities option:selected').val();
//       if (country !== '' && city !== '') {
    $search.addClass('loading');
    const result = await getPractitioners(country, city, page);
    console.log(result);
//     	console.log(result.meta);
    practitioners = result.data;
    if(empty){ $practitioners.empty(); }
    result.data.forEach(p => {
      const prac_city = p.address ? p.address.city : '';          
      const prac_country = p.address ? p.address.country.name : '';
      const $practitioner = $(`<div class="practitioner-content grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half" id="practitioner${p.uuid}" data-uuid="${p.uuid}">
          <div class="practitioners"><a class="avatar_wrapper"><button class="avatar avatar_btn" type="button" data-uuid="${p.uuid}"></button><img class="avatar" src="${p.avatar ? p.avatar : 'https://via.placeholder.com/360'}" data-uuid="${p.uuid}"/></a>
          <div class="practitioner-content-inner flexible">
                <h3 class="name">${p.first_name} ${p.last_name}</h3>          
          <p class="address">${prac_city} ${prac_country}</p>
        </div></div></div>`);
      $practitioners.append($practitioner);
    });
  const res_current_page = result.meta.current_page;
  const res_next_page = res_current_page + 1;
  const res_last_page = result.meta.last_page;
  if(res_current_page < res_last_page){
    $loadMore.addClass('active');
    var load_more_button = document.querySelector('#triggerLoadMore');
    load_more_button.setAttribute('data-current-page', res_current_page);        
    load_more_button.setAttribute('data-next-page', res_next_page);
    load_more_button.setAttribute('data-last-page', res_last_page);        
  } else {
    $loadMore.removeClass('active');
  }
  $search.removeClass('loading');      
};
  $search.on('click', async (e) => {
      await initPractitionerSearch(1, true);
    $('#btnClear').show();
  });
  $( "#triggerLoadMore" ).click(function(e) {
    e.preventDefault();
    var next_page = document.getElementById('triggerLoadMore').getAttribute('data-next-page');
    initPractitionerSearch(next_page, false);
  }); 	
  $( document ).ready(function() {
      setTimeout(function(){
      initPractitionerSearch(1, true);
  }, 1000);
  });  
  $(document).on('click', '.grid__item', (e) => {
    const uuid = $(e.target).data('uuid');
    if (uuid !== undefined){
      const practitioner = practitioners.find(p => p.uuid === uuid);
      showModal(practitioner);
      return false;
    }
  });
  $(document).on('click', '.contact-trigger', (e) => {
    e.preventDefault();
    $(e.target.classList.toggle("active"));
    const practitioner_email = $(e.target).data('email');
    $(e.target.nextElementSibling.classList.toggle("active"));
  });
  // Show hide testimonial texts
  $(document).on('click', '.testimonial-content span', (e) => {
    e.preventDefault();
    $(e.target.parentElement.classList.toggle("show-more"));
  });
  $close.on('click', (e) => {
    $('#testimonial-content').remove();
    $('.contact-trigger').removeClass('active');
    $('.contact-trigger').next().removeClass('active');
    $(document.body).removeClass('body-class');
    let list = document.getElementById("practitioners--testimonials");
    // As long as <ul> has a child node, remove it
    while (list.hasChildNodes()) {  
      list.removeChild(list.firstChild);
    }
    $modal.hide();
  });
  getCountires();
})